<template>
    <div style="width: 98%; display: block; margin: auto;">
        <b-alert show variant="secondary">
            <h5><b>DISCREPANCIES</b></h5>
            <sub>This tool shows all the invoice items which have any dicrepancy (i.e. cannot be pulled, cannot be shipped, cannot be delivered, etc.).</sub>
        </b-alert>

        <b-card>
            <b-form-select :options="options" v-model="option" @change="get_data" style="width: 200px;">
            </b-form-select>
        </b-card>

        <div style="padding: 5px; margin-top: 10px; min-height: 100px; width: 100%;">
            <b-modal id="modal-disc-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
                <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
            </b-modal>
             <div v-if="items_being_loaded">
                <loading
                :active="true"
                :can-cancel="false"
                :is-full-page="false">
                </loading>
            </div>
            <div v-else>
                <div v-if="items.length > 0" style="overflow-x: auto;">
                    <table class="text-monospace" style="width: 100%; margin-top: 5px;">
                        <thead>
                            <tr style="background: #c3cdd3;">
                                <th class="ipt_tdhr" v-on:click="sortby('ts')">
                                    ORDER DATE
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('invoice_id')">
                                    INVOICE #
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('parent_product_sku')">
                                    PARENT SKU
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('product_sku')">
                                    PRODUCT SKU
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('quantity')">
                                    QTY
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('order_type')">
                                    ORDER TYPE
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('merchandise_status')">
                                    MERCH STATUS
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('pull_date')">
                                    PULL DATE
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('delivery_date')">
                                    DELIVERY DATE
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('locsub')">
                                    FLFILL FROM
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('pickup_truck', packet.trucksdict)">
                                    PICK TRUCK
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('drop_locsub')">
                                    DROP LOC
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('state')">
                                    STATUS
                                </th>
                                <th class="ipt_tdhr" v-on:click="sortby('truck', packet.trucksdict)">
                                    DELVRY TRUCK
                                </th>
                                <th class="ipt_tdhr" style="width: 120px;">
                                    ACTION
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="item, idx in items" v-bind:key="idx">
                                <td class="ipt_tdr" style="">
                                    {{ item.ts }}
                                </td>
                                <td class="ipt_tdr" style="">
                                    {{ item.invoice_id }}
                                </td>
                                <td class="ipt_tdr" >
                                    {{ item.parent_product_sku }}
                                </td>
                                <td class="ipt_tdr" >
                                    {{ item.product_sku }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.quantity }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.order_type }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ merchandise_status_dict[item.merchandise_status]}}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.pull_date }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ item.delivery_date }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ packet.locsubsdict[item.locsub] }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ packet.trucksdict[item.pickup_truck] }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ packet.locsubsdict[item.drop_locsub] }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ states_dict[item.state] }}
                                </td>
                                <td class="ipt_tdr">
                                    {{ packet.trucksdict[item.truck] }}
                                </td>
                                <td class="ipt_tdr">
                                    <!-- <div style="margin: 3px;"><button :disabled="is_action_disabled()">ARCHIVE</button></div>
 -->
                                    <div style="margin: 3px;">
                                        <button @click="show_comments(item)">CMNTS <span v-if="comments_dict[item.invoice_id+'|'+item.itemid]" style="color: red;">({{ comments_dict[item.invoice_id+'|'+item.itemid]}})</span></button>
                                    </div>

                                    <div style="margin: 3px;">
                                        <button v-if="item.discrepancy_archived == false" @click="change_discrepancy_archive_status(item, true)" style="border: 1px solid green;">ARCHIVE</button>
                                        <button v-else @click="change_discrepancy_archive_status(item, false)" style="border: 1px solid red;">UNARCHIVE</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <b-alert variant="warning" show>NO DISCREPANCIES TO SHOW</b-alert>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    import ItemComments from '@/components/importables/ItemComments'

    export default {
        name: "AdminToolsDiscrepancies",
        components: {
            Loading, ItemComments
        },
        data: function(){
            let out = {
                packet: {},
                items_being_loaded: null,
                items: [],
                option: 1,
                options: [
                    {value: 1, text: "ACTIVE"},
                    {value: 0, text: "ARCHIVED"},
                    {value: -1, text: "ALL"},
                ],
                merchandise_status_dict: {
                    1: "IN-STOCK",
                    2: "BACKORDER",
                    3: "SPECIAL"
                },
                states: mappings.states,
                states_dict: mappings.states_dict,
                sort_asc: true,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                comments_dict: {},
            }
            return out
        },
        methods: {
            change_discrepancy_archive_status: function(item, archive){
                let path = "/api/sales/change_discrepancy_archive_status/"
                let data = {archive: archive, invoice_id: item.invoice_id, itemid: item.itemid}
                let that = this;
                let s = function(response){
                    if (!response.data.error){
                        that.$bvToast.toast(
                            "UPDATED ARCHIVE STATUS",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        item.archive = archive;

                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }


                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "ERROR UPDATING ARCHIVE STATUS.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                };
                Requestor.postAsyncP(path, data, this, s, f);
            },
            is_action_disabled: function(e){
                let status = false;
                if (e){
                    e.preventDefault();
                }

                let userrole= this.packet.userDetails.userrole;
                if (['locationadmin', 'salesperson', 'warehouseuser', 'warehousemanager'].includes(userrole)){
                    status = true
                }
                return status
            },
            get_data: function(){
                let path = "/api/sales/get_discrepancies/"
                let data = {option: this.option}

                // if (this.packet.userDetails.properties.location_id){
                //     data.location_id = data.location_id;
                // }
                let that = this;
                let s = function(response){
                    if (!response.data.error){
                        that.items = response.data.result;
                        that.get_batch_comments();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }

                    that.items_being_loaded = false;
                }

                let f = function(error){
                    console.log(error)
                    that.$bvToast.toast(
                        "Error updating item.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                this.items = [];
                this.items_being_loaded = true;
                Requestor.getAsync(path, data, s, f);
            },
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-disc-comments");
            },
            get_batch_comments: function(){
                let items = this.items.map(function(d){
                    return {invoice_id: d.invoice_id, itemid: d.itemid}
                })
                let path = "/api/sales/get_batch_comments/"
                let data = {items: items};
                let that = this;
                let s = function(response){
                    if (response.data.result){
                        //that.items = response.data.result;
                        console.log(response.data.result);
                        let comments = response.data.result;
                        if (comments.length > 0){
                            that.comments_dict = Object.assign({}, ...comments.map((x) => ({[x.invoice_id+'|'+x.itemid]: x.n_comments})));
                            console.log(that.comments_dict);
                        }

                    }
                    else {
                        console.log(response.data.error)
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                }

                let f = function(error){
                    that.$bvToast.toast(
                        "Error loading comments.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                }

                Requestor.postAsync(path, data, s, f);
            },
        },
        created: function(){
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.get_data()
        }

    }

</script>

<style scoped>
    .ipt_tdr {
        font-size: 11px !important;
        background: white;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdminTools/AdminToolsDiscrepancies.vue